(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nst-lookbook-single"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.nstLbReady) return;
      var track = root.querySelector('[data-nst-lb-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-nst-lb-slide]'));
      if (slides.length < 2) return;
      root.dataset.nstLbReady = '1';

      var prev = root.querySelector('[data-nst-lb-prev]');
      var next = root.querySelector('[data-nst-lb-next]');
      var controls = root.querySelector('[data-nst-lb-controls]');
      var toggle = root.querySelector('[data-nst-lb-toggle]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nst-lb-dot]'));
      var interval = parseInt(root.dataset.interval, 10) || 5000;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var active = 0;
      var timer = null;
      var stopped = reduced || root.dataset.autoplay !== 'true';
      var hovering = false;
      var focused = false;
      var inView = false;

      [prev, next, controls].forEach(function (el) { if (el) el.hidden = false; });

      function goTo(i) {
        var n = slides.length;
        i = ((i % n) + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        setActive(i);
      }
      function setActive(i) {
        active = i;
        dots.forEach(function (d, k) {
          if (k === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      function canRotate() {
        return !stopped && !hovering && !focused && inView && !document.hidden;
      }
      function schedule() {
        clearTimeout(timer);
        timer = null;
        track.setAttribute('aria-live', canRotate() ? 'off' : 'polite');
        if (canRotate()) {
          timer = setTimeout(function () { goTo(active + 1); schedule(); }, interval);
        }
      }
      function setStopped(value) {
        stopped = value;
        if (toggle) {
          toggle.classList.toggle('is-paused', stopped);
          toggle.setAttribute('aria-label', stopped ? 'Play slideshow' : 'Pause slideshow');
        }
        schedule();
      }

      if (prev) prev.addEventListener('click', function () { goTo(active - 1); schedule(); });
      if (next) next.addEventListener('click', function () { goTo(active + 1); schedule(); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); schedule(); }); });
      if (toggle) toggle.addEventListener('click', function () { setStopped(!stopped); });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
      });
      root.addEventListener('mouseenter', function () { hovering = true; schedule(); });
      root.addEventListener('mouseleave', function () { hovering = false; schedule(); });
      root.addEventListener('focusin', function (e) {
        focused = e.target !== toggle;
        schedule();
      });
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) { focused = false; schedule(); }
      });
      root.addEventListener('touchstart', function (e) {
        if (toggle && toggle.contains(e.target)) return;
        if (!stopped) setStopped(true);
      }, { passive: true });

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== active && i >= 0 && i < slides.length) setActive(i);
        });
      }, { passive: true });

      document.addEventListener('visibilitychange', schedule);

      if ('IntersectionObserver' in window) {
        var warmed = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            inView = en.isIntersecting;
            if (inView && !warmed) {
              warmed = true;
              root.querySelectorAll('.nst-lookbook__img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
            }
          });
          schedule();
        }, { rootMargin: '200px 0px', threshold: 0.01 }).observe(root);
      } else {
        inView = true;
      }

      document.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target);
        if (i > -1) { setStopped(true); goTo(i); }
      });

      setStopped(stopped);
    }

    document.querySelectorAll('[data-nst-lb]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-nst-lb]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nst-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.nst-lookbook');
    roots.forEach(function (root) {
      var track = root.querySelector('[data-nst-lb-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-nst-lb-card]'));
      if (cards.length < 2) return;
      var prev = root.querySelector('[data-nst-lb-prev]');
      var next = root.querySelector('[data-nst-lb-next]');
      var arrows = root.querySelector('[data-nst-lb-arrows]');
      var dotsWrap = root.querySelector('[data-nst-lb-dots]');
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-nst-lb-dot]')) : [];
      var counter = root.querySelector('[data-nst-lb-counter]');
      var current = root.querySelector('[data-nst-lb-current]');
      var hint = root.querySelector('[data-nst-lb-hint]');
      var active = 0;

      function padStart() {
        var cs = getComputedStyle(track);
        return parseFloat(cs.paddingInlineStart || cs.paddingLeft) || 0;
      }
      function goTo(i) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({ left: cards[i].offsetLeft - padStart(), behavior: 'smooth' });
      }
      function setActive(i) {
        if (i === active) return;
        active = i;
        dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        if (current) current.textContent = String(i + 1);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === cards.length - 1;
      }

      if (arrows) arrows.hidden = false;
      if (dotsWrap) dotsWrap.hidden = false;
      if (counter) counter.hidden = false;
      if (hint && window.matchMedia('(min-width: 990px)').matches) hint.hidden = true;
      if (prev) { prev.disabled = true; prev.addEventListener('click', function () { goTo(active - 1); }); }
      if (next) next.addEventListener('click', function () { goTo(active + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) setActive(cards.indexOf(en.target));
          });
        }, { root: track, threshold: [0.6] });
        cards.forEach(function (c) { io.observe(c); });
      } else {
        track.addEventListener('scroll', function () {
          var w = cards[0].getBoundingClientRect().width + 16;
          setActive(Math.round(track.scrollLeft / w));
        }, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
